import { useEffect } from 'react';
import { ACCOUNT_STATUSES } from 'common/constants';

const useSetMultiStepForPartiallyRegistered = ({
  accountStatus,
  activeType,
  setActiveType,
  types,
}) => {
  useEffect(() => {
    if (activeType?.templateName === 'MULTI_STEP') return;

    if (accountStatus === ACCOUNT_STATUSES.PARTIALLY_REGISTERED) {
      const multiStepType = types.find(type => type.templateName === 'MULTI_STEP');

      if (multiStepType) setActiveType(multiStepType);
    }
  }, [accountStatus, activeType, setActiveType, types]);
};

export default useSetMultiStepForPartiallyRegistered;
